/**
 * @fileoverview MultipleRoles
 *
 * MultipleRoles page related components initialization
 */
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Modal from '../../components/Modal';

class NetflixPage {
    
    constructor() {
        this._wrapper = SelectorEngine.findOne('.p-netflix-portal-landing');
        if(!this._wrapper) {
        return;
        }
        this.initiateSection();
    }

    initiateSection() {
        this.addnewRoleBtn = SelectorEngine.findOne('.lta-add-new-role-btn', this._wrapper);
        this._multipleRolesAddedModal = new Modal(document.querySelector('#multiple-roles-added'), {});
        this.exitRoleModal = SelectorEngine.findOne('.js-exit-multiple-role-modal');
        const showModal = SelectorEngine.findOne('.mega-nav-controls').getAttribute('data-show-modal');
        const redirectUrl = SelectorEngine.findOne('.mega-nav-controls').getAttribute('data-url');

        EventHandler.on(this.addnewRoleBtn, 'click', () => {
            if(showModal == 'true') {
                this._multipleRolesAddedModal.show();
            } else {
                window.location.href = redirectUrl;
            }
           
        });

        EventHandler.on(this.exitRoleModal, 'click', () => {
            this._multipleRolesAddedModal.hide();
        });
    }
}

const netflixPage = new NetflixPage();

export default netflixPage;

